import { render, staticRenderFns } from "./ordonnance_edit.vue?vue&type=template&id=5f5489cc&scoped=true&"
import script from "./ordonnance_edit.vue?vue&type=script&lang=js&"
export * from "./ordonnance_edit.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance_edit.vue?vue&type=style&index=0&id=5f5489cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5489cc",
  null
  
)

export default component.exports